import { render, staticRenderFns } from "./BankAccountListView.vue?vue&type=template&id=4584c159&scoped=true&"
import script from "./BankAccountListView.vue?vue&type=script&lang=js&"
export * from "./BankAccountListView.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountListView.vue?vue&type=style&index=0&id=4584c159&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4584c159",
  null
  
)

export default component.exports